/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {Component} from 'react';
import '/home/abcd/immoc_react/src/js/Head/Right_text/Shop/Shop.css'

class Shop_nav extends Component{
    render(){
        return(
            <div className="shop_nav">
                <div className="top">
                    <h2>我的购物车</h2>
                    <p>已加入0门课程</p>
                </div>
                <div className="mid">
                <span>
                    <svg t="1568159439694" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1252" width="73" height="73"><path d="M372.621175 553.482035C382.57664 556.741018 392.691302 558.545442 402.420736 558.545442L733.189257 558.545442C771.42883 558.545442 817.038814 531.169621 835.511774 496.556851L1014.654566 160.897707C1032.92614 126.662315 1016.540638 98.909116 977.261431 98.909116L236.61213 98.909116 180.363605 0 0 0 0 89.150601 104.116497 89.150601 111.143458 98.909116 111.143458 98.909116 110.08 98.909116 298.249626 486.577835 224.303036 618.502554C188.830242 681.787938 218.937481 738.826718 277.801165 744.562483L919.272721 744.562483 919.272721 651.781803 330.772139 651.781803C321.116911 651.781803 317.444983 644.897451 322.095445 637.192602L372.621175 553.482035ZM317.090884 994.909116C376.536815 994.909116 424.727279 946.718652 424.727279 887.272721 424.727279 827.82679 376.536815 779.636395 317.090884 779.636395 257.644954 779.636395 209.454558 827.82679 209.454558 887.272721 209.454558 946.718652 257.644954 994.909116 317.090884 994.909116ZM811.636395 994.909116C871.082257 994.909116 919.272721 946.718652 919.272721 887.272721 919.272721 827.82679 871.082257 779.636395 811.636395 779.636395 752.190464 779.636395 704 827.82679 704 887.272721 704 946.718652 752.190464 994.909116 811.636395 994.909116Z" p-id="1253" fill="#cdcdcd"></path></svg>
                </span>
                <h4>购物车里空空如也</h4>
                <p>快去这里选购你中意的课程</p>
                <a href="">实战课程</a>
                <a href="">就业班</a>
                </div>
                <div className="bottom">
                    <div>
                    <a className="left" href="">我的订单中心</a>
                    <a className="right" href="">去购物车</a>
                    </div>
                </div>
            </div>
        )
    }
}
export default Shop_nav